import { Box, Link, Typography } from '@mui/material'
import { contactSocialLinks } from '../../data/contactContent'
import { contactSectionTitleSx, contactSocialLinksBoxSx } from './contactLayout'
import {
  contactMobileSectionTitleSx,
  contactMobileSocialIconSx,
  contactMobileSocialRowSx,
  contactMobileSocialTileSx,
} from './contactMobileLayout'

export default function ContactSocialSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 4, md: 6, lg: '444px' },
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{ ...contactSectionTitleSx, ...contactMobileSectionTitleSx }}
      >
        Connect With Us
      </Typography>

      <Box sx={{ ...contactSocialLinksBoxSx, ...contactMobileSocialRowSx }}>
        {contactSocialLinks.map((social) => (
          <Link
            key={social.label}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            sx={{
              flex: { xs: '1 1 0', sm: '1 1 0' },
              minWidth: 0,
              aspectRatio: { xs: '1 / 1', sm: '52 / 52' },
              maxHeight: { xs: 52, sm: 'none' },
              bgcolor: social.bg,
              borderRadius: { xs: '9px', sm: '20px' },
              p: { xs: '4.5px', sm: '10px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              boxSizing: 'border-box',
              ...contactMobileSocialTileSx,
            }}
          >
            <Box
              component="img"
              src={social.icon}
              alt={social.label}
              sx={{
                display: 'block',
                objectFit: 'contain',
                maxWidth: '100%',
                flexShrink: 0,
                ...social.iconSx,
                ...contactMobileSocialIconSx,
              }}
            />
          </Link>
        ))}
      </Box>
    </Box>
  )
}
